<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  const API_PATH = process.env.VUE_APP_API_URL;
  const API_WECHAT_OPENID = `${API_PATH}/mapi/insurance/insuranceRenew/publicAPI/queryOpenIdWX.json`;
  const ua = navigator.userAgent;
  const isMobile = ua.indexOf("Android") >= 0 || ua.indexOf("iPhone") >= 0;
  const style = document.createElement("style");
  style.type = "text/css";

  if (isMobile) {
    // 输入框在虚拟键盘弹出时，自动滚动到可见位置
    document.body.addEventListener(
      "click",
      function(event) {
        let element = event.target;
        let tags = {
          INPUT: 1,
          TEXTAREA: 1
        };
        if (element.tagName in tags) {
          setTimeout(function() {
            element.scrollIntoViewIfNeeded();
          }, 400);
        }
      },
      false
    );
  }
  // rem 布局计算
  // (function(doc, win) {
  //   let docEl = doc.documentElement;
  //   let resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
  //   let recalc = function() {
  //     let clientWidth = docEl.clientWidth;
  //     if (!clientWidth) return;
  //     docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
  //   };
  //   if (!doc.addEventListener) return;
  //   win.addEventListener(resizeEvt, recalc, false);
  //   doc.addEventListener("DOMContentLoaded", recalc, false);
  // })(document, window);
  
  export default {
    data() {
      return {
        name: 'app',
        appid: process.env.VUE_APP_MODE === 'production' ? 'wx5807919be7483f75' : 'wxb166ff45af44d0ce',
        redirecturi: '',
        scopetype: 'snsapi_base' // 静默授权
      }
    },

    methods: {
      toWechatOauth() {
        this.redirecturi = encodeURIComponent(location.href);
        let wechatOauthUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ this.appid +'&redirect_uri='+ this.redirecturi +'&response_type=code&scope='+ this.scopetype +'&state=STATE&connect_redirect=1#wechat_redirect';
        window.location.href = wechatOauthUrl;
      },
      getCode() {
        let url = location.href;
        let req = {};
        if (url.indexOf('code=') > -1) {
          let query = url.split('?')[1];
          let params = query.split('&');
          params.map((item) => {
            let kv = item.split('=');
            req[kv[0]] = kv[1];
          });
        }
        return req['code'];
      },
      async getOpenid() {
        let code = this.getCode();
        if (code) {
          const response = await axios.post(API_WECHAT_OPENID, {
            code: code
          });
          if (response.code === 1 && response.data) {
            this.$cookie.set('p-appid', this.appid, {expires: '1D'});
            this.$cookie.set('p-openId', response.data, {expires: '1D'});
            return;
          } else {
            //alert(JSON.stringify(response))
          }
        } else {
          this.toWechatOauth();
        }
      }
    },

    mounted() {
      /*微信客户端，需要走授权过程*/
      if (this.$store.state.isWeChat) {
        let openId = this.$cookie.get('p-openId');
        let appid = this.$cookie.get('p-appid');
        if ((appid == this.appid) && openId) {
        } else {
          this.getOpenid()
        }
      }
    },
    components: {
    }
  }

</script>

<style lang="stylus">
  * {
    padding: 0;
    margin: 0;
    list-style: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-touch-callout: none;
    box-sizing: border-box;
  }

  html, body {
    position: relative;
    height: 100%;
    width: 100%;
    font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
    overflow-x: hidden;
    background: #fff;
    -webkit-text-size-adjust: 100%;
    -webkit-overflow-scrolling: touch;
  }

  body #app {
    height: 100%;
    overflow-y: scroll;
    font-size: 14px;
  }
  
  a { 
    text-decoration: none; 
    color: #2196f3; 
  }
  img[src=""],img:not([src]){opacity:0;}
  a, input, textarea, button, select { resize: none; outline: 0; }
</style>
